import {UserProps} from 'modules/users/types';
import useEditProfile from 'modules/users/hooks/use-edit-profile';
import React from 'react';
import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';

const Profile: React.FC = () => {
  const handleSubmit = (data: UserProps) => {
    const {name, email, password, phone, cpf} = data;

    return {
      name,
      email,
      password,
      phone,
      cpf,
    };
  };

  const {getInput} = useFormInputs<UserProps>();

  return (
    <Edition<UserProps>
      titleBar={{title: 'Editar perfil'}}
      translationKey="UserProps"
      onSubmit={() => useEditProfile()}
      detailsUrl={'/users/me'}
      {...{handleSubmit}}
      inputs={[
        getInput({
          name: 'name',
          disabled: true,
        }),
        getInput({
          name: 'email',
          disabled: true,
        }),
        getInput({
          name: 'phone',
          mask: 'phone',
        }),
        getInput({
          name: 'cpf',
          mask: 'cpf',
        }),
      ]}
    />
  );
};

export default Profile;
